export const SONGS_ENDPOINT = "/api/songs/";
export const TAGS_ENDPOINT = "/api/tags/";
export const GAMMA_SIGNOUT_ENDPOINT = "/api/signout";
export const GAMMA_ME_ENDPOINT = "/api/me";
export const GAMMA_AUTH_ENDPOINT = "/api/auth";
